// Import the necessary functions from Firebase SDK
import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue, get, child } from "firebase/database";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDJliWun-g8mONxdoGOqrZc0qSDO96NpmM",
    authDomain: "digitalstorage-95e62.firebaseapp.com",
    databaseURL: "https://digitalstorage-95e62.firebaseio.com",
    projectId: "digitalstorage-95e62",
    storageBucket: "digitalstorage-95e62.appspot.com",
    messagingSenderId: "840597919830",
    appId: "1:840597919830:web:b428ee690012a3a542c3f7",
    measurementId: "G-YYJTR1N92Z"
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Initialize Realtime Database and get a reference to the service
const database = getDatabase(app);

// Function to fetch data once
export const fetchDataOnce = async (path) => {
  const dbRef = ref(database);
  try {
    const snapshot = await get(child(dbRef, path));
    if (snapshot.exists()) {
      return snapshot.val(); // return the data to use in your component
    } else {
      console.log("No data available");
      return null;
    }
  } catch (error) {
    console.error("Error fetching data: ", error);
    return null;
  }
};

// Function to fetch real-time data
export const fetchRealTimeData = (path, callback) => {
  const dataRef = ref(database, path);
  
  // Set up listener for real-time updates
  onValue(dataRef, (snapshot) => {
    const data = snapshot.val();
    callback(data); // use the callback to update data in your component
  });
};

